module.exports = __webpack_public_path__ + "img/手机端商品SKU.8a9ae203.png";